var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-end"},[_c('h4',[_c('i',{staticClass:"el-icon-arrow-up"}),_vm._v(" メイン 終了 ")])])}]

export { render, staticRenderFns }